module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"使い方","description":"WareXの使い方ガイドです。登録の仕方や倉庫の探し方、問い合わせ方法、入出荷方法など、使い方をご紹介します。","lead":"WareXのご利用方法を、{newline-sp}実際の画面と合わせてご紹介します。"},"en":{"title":"How to Use"}}')
  delete Component.options._Ctor
}
